import { render, staticRenderFns } from "./ContractDocumentReplacement.vue?vue&type=template&id=38e1cee6&scoped=true"
import script from "./ContractDocumentReplacement.vue?vue&type=script&lang=js"
export * from "./ContractDocumentReplacement.vue?vue&type=script&lang=js"
import style0 from "./ContractDocumentReplacement.vue?vue&type=style&index=0&id=38e1cee6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e1cee6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38e1cee6')) {
      api.createRecord('38e1cee6', component.options)
    } else {
      api.reload('38e1cee6', component.options)
    }
    module.hot.accept("./ContractDocumentReplacement.vue?vue&type=template&id=38e1cee6&scoped=true", function () {
      api.rerender('38e1cee6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/components/ContractDocumentReplacement.vue"
export default component.exports